import React, { useEffect } from 'react';
import './Header.css';
import ToolSwitch from './ToolSwitch';

const Header = ({
  totalPoints,
  totalLeds = 0,
  currentTool = 'normal',
  onChangeTool,
  onOpenSidebar,
  onExportConfig,
  onImportConfig,
  currentImage
}) => {
  const handleImportClick = () => {
    document.getElementById('import-config')?.click();
  };

  // Atalho de teclado: T alterna, 1 (Luz), 2 (LED)
  useEffect(() => {
    const onKey = (e) => {
      if (['INPUT', 'TEXTAREA'].includes(document.activeElement?.tagName)) return;
      if (e.key.toLowerCase() === 't') {
        onChangeTool?.(currentTool === 'normal' ? 'ledStrip' : 'normal');
      } else if (e.key === '1') {
        onChangeTool?.('normal');
      } else if (e.key === '2') {
        onChangeTool?.('ledStrip');
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [currentTool, onChangeTool]);

  const hasAnyInstances = (totalPoints || 0) + (totalLeds || 0) > 0;

  return (
    <header className="app-header">
      <div className="header-content">
        {/* Marca */}
        <div className="header-brand">
          <div className="logo">
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
              <path
                d="M12 2L2 7L12 12L22 7L12 2Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinejoin="round"
                fill="rgba(255,255,255,0.1)"
              />
              <path
                d="M2 17L12 22L22 17"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinejoin="round"
              />
              <path
                d="M2 12L12 17L22 12"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinejoin="round"
              />
              <circle cx="12" cy="7" r="2" fill="currentColor" />
              <circle cx="12" cy="12" r="1.5" fill="currentColor" />
              <circle cx="12" cy="17" r="1" fill="currentColor" />
            </svg>
          </div>
          <div className="brand-text">
            <h1>CMD TOOLS</h1>
          </div>
        </div>

        {/* Seletor de ferramenta (Luz / LED) */}
        <ToolSwitch value={currentTool} onChange={onChangeTool} />

        {/* Estatísticas */}
        <div className="header-stats">
          <div className="stat-item">
            <span className="header-stat-value">{totalPoints}</span>
            <span className="header-stat-label">Pontos</span>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-item">
            <span className="header-stat-value">{totalLeds}</span>
            <span className="header-stat-label">Fitas LED</span>
          </div>
        </div>

        {/* Ações */}
        <div className="header-actions">
          <button
            className="header-btn btn-secondary"
            onClick={() => onOpenSidebar('upload')}
            title="Carregar ou trocar imagem da planta"
          >
            📁 Planta
          </button>

          <button
            className="header-btn btn-secondary"
            onClick={() => onOpenSidebar('controls')}
            title="Abrir painel de configurações"
          >
            ⚙️ Config
          </button>

          <button
            className="header-btn btn-secondary"
            onClick={() => onOpenSidebar('json')}
            title="Visualizar código JS gerado"
          >
            📄 JS
          </button>

          <button
            className="header-btn btn-secondary"
            onClick={handleImportClick}
            title="Importar configuração existente"
          >
            📥 Importar
          </button>

          <button
            className="header-btn btn-primary"
            onClick={onExportConfig}
            disabled={!hasAnyInstances}
            title="Exportar configuração (JS)"
          >
            📤 Exportar
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;